<template>
<vs-row>
    <vx-card style="min-height:500px">
        <vs-row>
            <vs-alert color="danger" icon-pack="feather" icon="icon-info" v-for="(errors,err) in errorMessage" v-bind:key="err">
                <span>{{errors}}</span>
            </vs-alert>
        </vs-row>
        <div class="vx-row w-1/2" style="margin-top:20px;margin-left:29px">
            <div class="vx-col w-1/4 ">
                <span>
                    <p style="font-size:13.2px;font-weight:600;padding-top:6px;" >Doctor Name</p>
                </span>
            </div>
            <div class="vx-col w-1/2 ">
                <select v-model="doctorSelected" class=" vs-select--input myselect" name="Doctor" style="height: 36px;" v-validate="'required'" @change="getConfigList">
                    <option v-for="(item,index) in doctorList" v-bind:key="index" :value="item.id">{{item.name}}</option>
                </select>
                <!-- <vs-select v-validate="'required'" class="selectExample" v-model="doctorSelected" @change="getConfigList" name="Doctor">
                    <vs-select-item :value="item.id" :text="item.name" v-for="(item,index) in doctorList" v-bind:key="index" />
                </vs-select> -->
            </div>
            <div class="vx-col w-1/4">
                <div :class="{'activeLoading':activeLoading}" :id="[`loading-material`]" class="vs-con-loading__container loading-example">
                </div>
            </div>
        </div>

        <div class="vx-row w-full" style="padding-left: 4%;
padding-right: 5%;">
            <vs-col vs-lg="12">
                <table style="margin-top:20px;">

                    <thead>
                        <th style="width:8%">Day</th>
                        <th style="width:12%">Shift Name</th>
                        <th style="width:10%">Consultation Start Time</th>
                        <th style="width:8%">Duration (Mins)</th>
                        <th style="width:12%">Token Available</th>
                        <th style="width:10%">Consultation End Time</th>
                        <th style="width:12%">Auto Schedule Day</th>  
                      <th style="width:9%">Booking Start Time</th>
                      <th style="width:9%">Booking End Time</th>
                        <th style="width:3%">&nbsp;</th>

                    </thead>
                    <tr v-for="(config,index) in configList" v-bind:key="index">
                        <td>
                            <select v-model="config.day" class=" vs-select--input myselect" style="height:36px;">
                                <option v-for="(item,index) in weekdays" v-bind:key="index" :value="item.value">{{item.text}}</option>
                            </select>
                            <!-- <vs-select class="selectExample configclass" v-model="config.day">
                                <vs-select-item :value="item.value" :text="item.text" v-for="(item,index) in weekdays" v-bind:key="index" />
                            </vs-select> -->
                        </td>
                        <td>
                            <select v-model="config.shiftId" class=" vs-select--input myselect" style="height:36px;">
                                <option class="vs-component" v-for="(item,index) in shifts" v-bind:key="index" :value="item.value">{{item.text}}</option>
                            </select>
                            <!-- <vs-select class="selectExample configclass" v-model="config.shiftId">
                                <vs-select-item :value="item.value" :text="item.text" v-for="(item,index) in shifts" v-bind:key="index" />
                            </vs-select> -->
                        </td>
                        <td>
                            <input type="time" v-model="config.shiftTime" class="configclass timeinput" @change="triggerEndTime(index)">
                        </td>
                        <td>
                            <vs-input v-model="config.duration"  class="configclass duration-center" @keyup="triggerEndTime(index)" :name="'Duration @ row-'+(index+1)" />
                        </td>
                        <td>
                            <vs-input v-model="config.maxAvailableTokens" class="configclass" @keyup="triggerEndTime(index)" />
                        </td>
                        <td>
                            <input type="time" v-model="config.endTime" class="configclass timeinput" @keydown.tab="insertRow(index)" readonly>
                        </td>
                          <td>
                        <select v-model="config.autoScheduleDay" class="vs-select--input myselect" style="height:36px;">
                            <option v-for="(item,index) in weekdays" v-bind:key="index" :value="item.value">{{item.text}}</option>
                        </select>
                        </td>
                        <td>
                        <input type="time" v-model="config.autoScheduleTime" class="configclass timeinput">
                        </td>
                                                <td>
                        <input type="time" v-model="config.bookingEndTime" class="configclass timeinput">
                        </td>
                        <td>
                            <feather-icon icon="Trash2Icon" class="mr-0 cursor-pointer" @click="openConfirm(index)"></feather-icon>
                        </td>

                      

                    </tr>
                </table>
            </vs-col>
        </div>
        <vs-row style="display: block;">
            <vs-button style="margin-top: 8px;margin-bottom:8px;float: right;margin-right:8%;" id="button-with-loading" class="float-center vs-con-loading__container" @click="validateForm" color="success" type="filled">Save</vs-button>
        </vs-row>
    </vx-card>
</vs-row>
</template>

<script>
export default {

    data() {
        return {
            activeLoading: false,
            errorMessage: [],
            deleteRowIndex: "",
            configList: [{
                "doctorId": "",
                "day": "",
                "shiftId": "",
                "shiftName": "",
                "shiftTime": "",
                "maxAvailableTokens": "",
                "duration": "",
                "companyId": "",
                "endTime": "",
               "autoScheduleDay": "",
               "autoScheduleTime":"",
               "bookingEndTime":"",
               
            }],
            doctorList:[{id:0,name:"Select"}],
            doctorSelected: 0,
            weekdays: [{
                    text: 'Sunday',
                    value: 1
                },
                {
                    text: 'Monday',
                    value: 2
                },
                {
                    text: 'Tuesday',
                    value: 3
                },
                {
                    text: 'Wednesday',
                    value: 4
                },
                {
                    text: 'Thursday',
                    value: 5
                },
                {
                    text: 'Friday',
                    value: 6
                },
                {
                    text: 'Saturday',
                    value: 7
                }

            ],
            shifts: [{
                    text: 'Morning',
                    value: 1
                },
                {
                    text: 'Afternoon',
                    value: 2
                },
                {
                    text: 'Evening',
                    value: 3
                },
            ]
        }
    },

    mounted() {
        this.getDoctorList();
    },
    methods: {
        clear() {
            this.configList=[{
                "doctorId":"",
                "day": "",
                "shiftId": "",
                "shiftName": "",
                "shiftTime": "",
                "maxAvailableTokens": "",
                "duration": "",
                "companyId": "",
                "endTime": "",
                 "bookingEndTime":"",

            }]
           this.doctorSelected=0;
        },
        openLoading() {
            this.activeLoading = true
            this.$vs.loading();
        },
         generateCron(day, time) {
    // time is in HH:mm (24hr)
    if (!time || !day) return "";

    let [hour, minute] = time.split(":");
  
    const dayMap = {
      1: "SUN",
      2: "MON",
      3: "TUE",
      4: "WED",
      5: "THU",
      6: "FRI",
      7: "SAT"
    };
    let cronDay = dayMap[day] || "?";

    return `0 ${minute} ${hour} * * ${cronDay}`;
  },
  parseCron(cron) {
  if (!cron) return { day: "", time: "" };

  let parts = cron.split(" ");  // ["0", "15", "10", "?", "*", "MON"]
  let minute = parts[1];
  let hour = parts[2];
  let day = parts[5];

  const reverseDayMap = {
    SUN: 1, MON: 2, TUE: 3, WED: 4, THU: 5, FRI: 6, SAT: 7
  };

  return {
    autoScheduleDay: reverseDayMap[day] || "",
    autoScheduleTime: `${hour.padStart(2, "0")}:${minute.padStart(2, "0")}`
  };
},

        getDoctorList() {
            var request = {
                companyId: this.$session.get('companyId')
            };
            this.$http.post(
                    "getdoctorlist",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    })
                .then(response => {
                    response.data.data.forEach((value) => {
                        this.doctorList.push(value);
                     })

                });
        },
        checkShiftTimeMatch(shiftId, shiftTime) {
  if (!shiftId || !shiftTime) return true;

  let [hour, minute] = shiftTime.split(":").map(Number);
  let totalMinutes = hour * 60 + minute;

  // Morning: 06:00 - 11:59
  if (shiftId === 1 && (totalMinutes < 360 || totalMinutes >= 720)) {
    return false;
  }
  // Afternoon: 12:00 - 16:59
  if (shiftId === 2 && (totalMinutes < 720 || totalMinutes >= 1020)) {
    return false;
  }
  // Evening: 17:00 - 22:00
  if (shiftId === 3 && (totalMinutes < 1020 || totalMinutes > 1320)) {
    return false;
  }
  return true;
},


        getConfigList(doctorId) {
            this.openLoading();
            this.errorMessage = [];
            var request = {
                companyId: this.$session.get('companyId'),
                doctorId: this.doctorSelected
            };
            this.$http.post(
                    "getdoctorconfigdetails",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    })
                .then(response => {
                    if (response.data.data) {
                        var myresponse = response.data.data;
                        myresponse.forEach((value) => {
                            value.endTime = this.calcEndTime(value.shiftTime, value.maxAvailableTokens, value.duration);
                             if (value.cronConf) {
                                const parsed = this.parseCron(value.cronConf);
                                value.autoScheduleDay = parsed.autoScheduleDay;
                                value.autoScheduleTime = parsed.autoScheduleTime;
                               // console.log("Autoscheduled day", value.autoScheduleDay )
                                //  console.log("Autoscheduled Time", value.autoScheduleTime )

                            } else {
                                value.autoScheduleDay = "";
                                value.autoScheduleTime = "";
                            }
                        });
                        this.configList = myresponse;
                        this.$vs.loading.close();
                    } else {
                        this.configList = [{
                            "doctorId": "",
                            "day": "",
                            "shiftId": "",
                            "shiftName": "",
                            "shiftTime": "",
                            "maxAvailableTokens": "",
                            "duration": "",
                            "companyId": "",
                            "endTime": ""
                        }];
                         this.$vs.loading.close();
                    }
                });
        },
         
        deleteRow() {
            if (this.$delete(this.configList, this.deleteRowIndex)) {
                this.acceptAlert;
            }
        },
        insertRow(index) {
            if (this.configList.length == (index + 1)) {
                var newrow = {
                    "doctorId": "",
                    "day": "",
                    "shiftId": "",
                    "shiftName": "",
                    "shiftTime": "",
                    "maxAvailableTokens": "",
                    "duration": "",
                    "companyId": "",
                    "endTime": "",
                    "bookingEndTime":"",
                }
                this.configList.push(newrow)
            }
        },
        calcEndTime: function (startTime, tokenDuration, maxTokenAvailable) {

            var Duration = tokenDuration * maxTokenAvailable;
            var hour = Math.floor(Duration / 60);
            var min = Duration % 60;
            var s = startTime.split(":");
            min = parseInt(s[1]) + parseInt(min);
            var hour_carry = 0;
            if (min >= 60) {
                min -= 60;
                hour_carry += 1;
            }
            hour = parseInt(s[0]) + parseInt(hour) + hour_carry;
            hour = hour < 10 ? '0' + hour : hour;
            min = min < 10 ? '0' + min : min;
            return hour + ":" + min;
        },
        triggerEndTime(index) {
            var data = this.configList[index];
            var startTime = data.shiftTime;
            var tokenDuration = data.duration;
            var maxTokenAvailable = data.maxAvailableTokens;
            this.configList[index].endTime = this.calcEndTime(startTime, tokenDuration, maxTokenAvailable);

        },
        openConfirm(index) {
            this.deleteRowIndex = index;
            if (this.configList.length != 1) {
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: `Confirm`,
                    text: 'Are you sure to Delete',
                    accept: this.acceptAlert
                });
            } else {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Invalid',
                    text: 'First Row Cannot Delete'
                })
            }

        },
        acceptAlert() {
            this.$delete(this.configList, this.deleteRowIndex);
            this.$vs.notify({
                color: 'danger',
                title: 'Deleted',
                text: 'The Row was successfully deleted'
            })
        },
        saveConfig: function () {
            this.buttonLoading();
              let configs = this.configList.map(cfg => {
                
                return {
                ...cfg,
                cronConf: this.generateCron(cfg.autoScheduleDay, cfg.autoScheduleTime)
                };
            });
            var request = {
                companyId: this.$session.get('companyId'),
                doctorId: this.doctorSelected,
                data: configs
            };
            console.log( JSON.stringify(request));
            this.$http.post(
                    "savedoctorconfigs",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    })
                .then(response => {
                    this.$vs.loading.close("#button-with-loading > .con-vs-loading");
                    document.getElementById('button-with-loading').disabled=false;
                    this.$vs.notify({
                        title: 'Saved Successfully',
                        color: 'success',
                        iconPack: 'feather',
                        icon: 'icon-check',
                        position: 'top-center'
                    });
                     this.clear();
                });
               
        },
        IsValidTime(timeString) {
            // var pattern = /^(?:1[0-2]|0[0-9]):[0-5][0-9]:[0-5][0-9]$/;
            var pattern = /([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;
            if (timeString.match(pattern)) {
                return true;
            } else {
                return false;
            }

        },
        isNumeric: function (n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        },
        buttonLoading() {
            document.getElementById('button-with-loading').disabled=true;
            this.$vs.loading({
                background: 'success',
                color: '#fff',
                container: "#button-with-loading",
                scale: 0.45
            })
        },
        validateForm() {

            var uniqueList = [];
            var duplicateList = [];
            var dayArray = [];
            this.errorMessage = [];

            if (!this.doctorSelected && this.doctorSelected == 0) {
                this.errorMessage.push("Doctor Field is Required");
            }
            this.configList.forEach((value, key) => {
                dayArray[key] = "k" + value.day + value.shiftId;
                if (!value.day && !value.shiftId && !value.maxAvailableTokens && !value.shiftTime && !value.duration && this.configList.length != 1) {
                    this.$delete(this.configList, key);
                } else {
                    if (!value.day) {
                        this.errorMessage.push("Day Field is Required");
                    }
                    if (!value.shiftId) {
                        this.errorMessage.push("Shift Field is Required");
                    }
                    if (!value.maxAvailableTokens) {
                        this.errorMessage.push("Token Available Field is Required");
                    } else if (!this.isNumeric(value.maxAvailableTokens)) {
                        this.errorMessage.push("Token Available Field is must be Numeric Value");
                    }
                    if (!value.shiftTime) {
                        this.errorMessage.push("ShiftTime Field is Required");
                    }
                    if (value.shiftId && value.shiftTime && !this.checkShiftTimeMatch(value.shiftId, value.shiftTime)) {
                        this.errorMessage.push(`Row ${key + 1}: Shift Time does not match selected Shift`);
                    }

                    if (!value.endTime) {
                        this.errorMessage.push("endTime Field is Required");

                    } else if (this.IsValidTime(value.endTime)==false) {
                        this.errorMessage.push("Invalid EndTime");
                    }
                    if (!value.bookingEndTime) {
                    this.errorMessage.push("Booking End Time Field is Required");
                } else if (this.IsValidTime(value.bookingEndTime) == false) {
                    this.errorMessage.push("Invalid Booking End Time");
                }
                if (value.shiftTime && value.bookingEndTime) {
                    if (value.bookingEndTime <= value.shiftTime) {
                        this.errorMessage.push(`Row ${key + 1}: End Time must be after Shift Start Time`);
                    }
                }


                    if (!value.duration) {
                        this.errorMessage.push("Duration Field is Required");
                    } else if (!this.isNumeric(value.duration)) {
                        this.errorMessage.push("Duration Field is Must be Numeric Value");
                    }
                }
            });
            dayArray.forEach(function (item, key) {
                if (!uniqueList.includes(item)) {
                    uniqueList.push(item);
                } else {
                    duplicateList.push(item);
                }
            })
            if (duplicateList.length > 0) {
                this.errorMessage.push("Same Shift in a day");

            }

            if (this.errorMessage.length == 0) {
                this.saveConfig();
            }

        }

    }
}
</script>

<style scoped>
table {
    border-collapse: collapse;
}

table th {
    text-align: center;
    line-height: 2.5rem;
}

table thead {
    background: #eaeff3;
}

.configclass {
    width: -webkit-fill-available;
}

.timeinput {
    padding: 7px;
    border-radius: 5px;
    border-style: groove;
    border-color: #fff8f891;
}

.cHeight {
    min-height: 550px;
}

.vs-input-primary::selection {
    outline: none !important;
    border: 1px solid red;
    box-shadow: 0 0 10px #719ECE;
}

</style>
